import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { InventoryTransferViewService } from "../../services/inventory-transfer-view.service";
import { ImportserialService } from "../../services/importserial.service";
import { AccountsTransactionType } from "src/app/finance/constants/constants";

@Component({
    selector: "app-inventory-transfer-view",
    templateUrl: "./inventory-transfer-view.component.html",
    styleUrls: ["./inventory-transfer-view.component.scss"],
})
export class InventoryTransferViewComponent implements OnInit, OnChanges {

    @Input() inventoryTransferId;
    transferDetail;
    qtyDecimal: number = 0;
    glApiCall = false;
    transactionTypeIds = AccountsTransactionType;
    @Input() visibleFromModule;


    constructor(
        private inventoryTransferViewService: InventoryTransferViewService,
        private appMainService: AppMainService, private importService: ImportserialService,
        private messageService: MessageService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.inventoryTransferId?.currentValue) {
            this.inventoryTransferId = changes.inventoryTransferId.currentValue;
            this.getInventoryTransferById(this.inventoryTransferId);
        }
    }

    ngOnInit(): void {
        this.importService.getQtyDecimalValue().subscribe(value => {
            if (value) {
                this.qtyDecimal = value
            }
        })
    }

    getInventoryTransferById(id) {
        this.transferDetail = null;
        this.appMainService.isShowSpinner("loadDetails");
        this.inventoryTransferViewService
            .getInventoryTransferById(id)
            .subscribe(
                (transfer) => {
                    this.transferDetail = transfer;
                    this.appMainService.isHideSpinner("loadDetails");
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                }
            );
    }

    showErrorMsg(err) {
        this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Error occurred...",
        });
    }

    onTabChange(event){
        if(event.index == 1){
            this.glApiCall = true;
        }
        else{
            this.glApiCall = false;
        }
    }
}
